import { forwardRef } from 'react';

import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva } from 'class-variance-authority';

import { cn } from '@/utils';

const toggleVariants = cva(
	'inline-flex items-center justify-center rounded-md text-xs font-bold leading-5 text-grey-500 ring-offset-background transition-colors hover:bg-white hover:text-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:bg-transparent disabled:text-grey-300 data-[state=on]:enabled:bg-red-background data-[state=on]:enabled:text-red',
	{
		variants: {
			variant: {
				default: 'bg-transparent',
				outline:
					'border border-transparent bg-transparent hover:border-black hover:bg-white data-[state=on]:border-transparent data-[state=on]:bg-white'
			},
			size: {
				default: 'px-2 py-1',
				sm: 'h-9 px-2.5',
				lg: 'min-h-[30px] min-w-20 flex-col rounded-lg px-2 py-2'
			}
		},
		defaultVariants: {
			variant: 'default',
			size: 'default'
		}
	}
);

const Toggle = forwardRef(({ className, variant, size, ...props }, ref) => (
	<TogglePrimitive.Root
		ref={ref}
		className={cn(toggleVariants({ variant, size, className }))}
		{...props}
	/>
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
